import PropTypes from "prop-types";

export const AccentBlue = ({ children }) => {
  return <span style={{ color: "#aad5ed" }}>{children}</span>;
};

AccentBlue.propTypes = {
  children: PropTypes.node,
};
